import AccountNav from "../../../../logic/navigation/accountNav";
import AccountLayout from "../structure/AccountLayout";
import AccountTertiaryNav from "../structure/AccountTertiaryNav";
import {Button} from "../../../../../components/general/input/Button";
import {useState} from "react";
import Popup from "../../../../../components/general/popup/Popup";
import Dialog from "../../../general/dialog/Dialog";
import DialogTitle from "../../../general/dialog/DialogTitle";
import DialogMessage from "../../../general/dialog/DialogMessage";
import Input from "../../../../../components/general/input/Input";
import DialogButtonContainer from "../../../general/dialog/DialogButtonContainer";
import DialogButton, {DIALOG_BUTTON_TYPE} from "../../../general/dialog/DialogButton";
import useAuthRequest from "../../../../services/state/request/useAuthRequest";
import {request} from "../../../../../res/rest/restRequest";
import {useNavigate} from "react-router-dom";
import useLogOut from "../../../../../components/state/account/useLogOut";
import VendorNav from "../../../../logic/navigation/vendorNav";
import useIsAccountPage from "../structure/useIsAccountPage";

const acctBreadcrumbTrail = [AccountNav.items.home, AccountNav.items.settings, {...AccountNav.items.deactivate, selected: true}];
const vendBreadcrumbTrail = [VendorNav.items.home, VendorNav.items.settings, {...VendorNav.items.deactivate, selected: true}];

const deactivateAccount = (session) => {
    return request.model("c_bpartner")
        .id(session.bPartnerID)
        .data({ isActive: false })
        .put(session);
}

const DeactivateAccountContent = () => {

    const [ showDelete, setShowDelete ] = useState(false);
    const [ showDeactivated, setShowDeactivate ] = useState(false);
    const [ warning, setWarning ] = useState(false);
    const [ input, setInput ] = useState("");

    const logOut = useLogOut();
    const navigate = useNavigate();

    const {
        loading,
        sendIt
    } = useAuthRequest();

    const onDone = () => {
        logOut();
        navigate("/");
    }

    const onCancel = () => {
        setInput("");
        setShowDelete(false);
        setWarning(false);
    }

    const onDeactivate = () => {
        if(input.toLowerCase() === "deactivate") {
            setShowDelete(false);
            sendIt(deactivateAccount, () => setShowDeactivate(true))
        } else {
            setWarning(true);
        }
    }

    return (
        <div className="acct-content">
            <p className="acct-h1">Deactivate Account</p>
            <p className="acct-val">In accordance with tax and regulatory requirements, we retain certain account information for record keeping purposes, including for VAT and other statutory obligations. As a result, full account deletion is not available. Instead, users may deactivate their accounts, which disables access while preserving essential records in compliance with applicable laws.</p>
            {showDeactivated &&
                <Popup>
                    <Dialog>
                        <DialogTitle>Account Deactivated</DialogTitle>
                        <DialogMessage>
                            Your account has been successfully deactivated
                        </DialogMessage>
                        <DialogButtonContainer>
                            <DialogButton onClick={onDone}>Ok</DialogButton>
                        </DialogButtonContainer>
                    </Dialog>
                </Popup>
            }
            {showDelete &&
                <Popup>
                    <Dialog>
                        <DialogTitle>Deactivate Account</DialogTitle>
                        {warning &&
                            <DialogMessage>
                                <b>
                                    You must type the word deactivate, this is to protect against accidental deactivation
                                </b>
                            </DialogMessage>
                        }
                        <DialogMessage>Please type <b>deactivate</b> below, and click the button, to deactivate your account</DialogMessage>
                        <Input hint="deactivate" style={{borderColor: "var(--warning)"}} onChange={e => setInput(e.target.value)} />
                        <DialogMessage />
                        <DialogButtonContainer>
                            <DialogButton type={DIALOG_BUTTON_TYPE.neutral} onClick={onCancel}>Cancel</DialogButton>
                            <DialogButton type={DIALOG_BUTTON_TYPE.negative} onClick={onDeactivate}>Deactivate</DialogButton>
                        </DialogButtonContainer>
                    </Dialog>
                </Popup>
            }
            <Button
                style={{backgroundColor: loading ? "var(--inactive)" : "var(--warning)"}}
                onClick={() => !loading && setShowDelete(true)}
            >
                Deactivate Account
            </Button>
        </div>
    )

}

const DeactivateLayout = () => {

    const isAccount = useIsAccountPage();
    const breadcrumbTrail = isAccount ? acctBreadcrumbTrail : vendBreadcrumbTrail;

    return (
        <AccountLayout breadcrumbTrail={breadcrumbTrail}>
            <AccountTertiaryNav navList={breadcrumbTrail[1].children} />
            <DeactivateAccountContent />
        </AccountLayout>
    )

}

export default DeactivateLayout;
